import { BlockEditorPlugin } from '../types';

export const createPlugin = (plugin: Omit<BlockEditorPlugin, 'install'> & {
  install: (editor: any) => void;
}): BlockEditorPlugin => {
  return {
    ...plugin,
    install: plugin.install
  };
};

// Example plugins
export const imageSearchPlugin = createPlugin({
  name: 'image-search',
  version: '1.0.0',
  install: (editor) => {
    // Plugin implementation would go here
    console.log('Image search plugin installed');
  }
});

export const wordPressPlugin = createPlugin({
  name: 'wordpress-integration',
  version: '1.0.0',
  install: (editor) => {
    // WordPress integration would go here
    console.log('WordPress plugin installed');
  }
});
